export default [
    "PFTT",
    "PFFTT",
    "PFPTTF",
    "PFTTF",
    "PFTT_7N6JS",
    "PFTT_8N7JS",
    "PFPTTF_7N7JS",
    "PFPTTF_7N8JS",
    "PFTTF_7N7JS",
    "PFTTF_7N8JS",
];